import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { dateTimeFormat } from "src/utils";
import { Link } from "react-router-dom";
import styles from "./expense.module.scss";
import { Expense } from "./expenseSlice";
import { activeStatusMapping, EMPTY_STRING, expenseTypeMapping } from "src/components/constant/constant";
import { expenseTypeColors } from "src/variable/randomColor";
import { expenseCategories } from "src/components/expenseComponent/createExpense/expenseCategories";

const columns = [
  {
    title: "Id",
    dataIndex: "expense_id",
    key: "expense_id"
  },
  {
    title: "Claim Date",
    dataIndex: "expense_date",
    key: "expense_date",
    render: (expense_date: string) => <div>{dateTimeFormat(expense_date).date}</div>
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    render: (title: string, record: Expense) => (
      <div className={styles.owner}>
        <span className={styles.title}>{title}</span>
        <span className={styles.description}>{record.description}</span>
      </div>
    )
  },
  {
    title: "Object Type",
    dataIndex: "object_type",
    key: "object_type",
    render: (object_type: string) => <div>{object_type}</div>
  },
  {
    title: "Type",
    dataIndex: "expense_type",
    key: "expense_type",
    render: (expense_type: string) => (
      <div
        className={styles.type}
        style={{
          color: `${expenseTypeColors[expense_type]}FF`,
          backgroundColor: `${expenseTypeColors[expense_type]}0d`,
          borderColor: `${expenseTypeColors[expense_type]}73`
        }}
      >
        {expenseTypeMapping[expense_type] || expense_type}
      </div>
    )
  },
  {
    title: "Category",
    dataIndex: "expense_category",
    key: "expense_category",
    render: (expense_category: string) => {
      const category = expenseCategories.find((item) => item.id === expense_category);

      if (!category) {
        return <div>{expense_category}</div>;
      }

      return (
        <div className={styles.categoryWrapper}>
          <span>{category.name}</span>
          {category.description && (
            <Tooltip
              title={category.description}
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "#1e293b",
                    fontSize: "13px",
                    padding: "8px 12px",
                    maxWidth: "320px",
                    lineHeight: 1.5
                  }
                }
              }}
            >
              <InfoOutlinedIcon className={styles.categoryInfoIcon} fontSize="small" />
            </Tooltip>
          )}
        </div>
      );
    }
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status: string) => (
      <div className={styles.tableStatus}>
        <div className={`${activeStatusMapping[status] ? styles.green : styles.grey}`}>
          {activeStatusMapping[status] ? "Active" : "Inactive"}
        </div>
      </div>
    )
  },
  {
    title: EMPTY_STRING,
    dataIndex: EMPTY_STRING,
    key: "operations",
    render: (data: Expense) => (
      <div className={styles.edit}>
        <Link
          to={`/claims/${data.expense_id}`}
          aria-label={`Edit claim ${data.title}`}
          title={`Edit claim ${data.title}`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M8.88541 3.05214L10.9478 5.11453M9.76042 2.17714C10.3299 1.60762 11.2533 1.60762 11.8228 2.17714C12.3924 2.74665 12.3924 3.67002 11.8228 4.23953L3.79167 12.2707H1.75V10.1876L9.76042 2.17714Z"
              stroke="#64748B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
    )
  }
];

export default columns;
